export default __webpack_public_path__ + "static/media/39.d6572c25.jpeg";